import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type React from "react";
import {memo, type ReactNode} from "react";

import {useMobileView} from "../../hooks/useMobileView";
import {CloseIcon} from "../../react/components/Icons";
import {useEventListener} from "../../react/hooks/useEventListener";
import ButtonIconTooltip from "../ButtonIconTooltip";
import {DrawerBackdrop, DrawerContent, DrawerUI} from "../ui/drawer";

export type Props = {
    isOpen: boolean;
    children?: ReactNode;
    onClose?: () => void;
};

const contentStyle = tva({
    variants: {
        isMobile: {
            false: "w-[500px]",
            true: ""
        }
    }
});

const Drawer: React.FC<Props> = ({children, isOpen, onClose}) => {
    const isMobile = useMobileView();
    useEventListener("keydown", e => {
        if (e.key === "Escape") {
            onClose?.();
        }
    });

    if (!isOpen) return null;

    return (
        <DrawerUI
            isOpen
            anchor={isMobile ? "bottom" : undefined}
            size={isMobile ? "full" : undefined}
            testID="drawer"
        >
            <DrawerBackdrop />
            <DrawerContent
                className={contentStyle({isMobile, className: "overflow-x-visible"})}
                customSize={isMobile ? undefined : 500}
            >
                <ButtonIconTooltip
                    className="fixed right-[500px] top-0"
                    icon={CloseIcon}
                    testID="btn-icon-close"
                    tooltip="Close"
                    onPress={onClose}
                />
                {children}
            </DrawerContent>
        </DrawerUI>
    );
};

export default memo(Drawer);
